<template>
  <div class="about">
    <!-- Navbar -->
    <navbar></navbar>

    <!-- Content -->
    <slot></slot>

    <!-- Upward Arrow -->
    <cq-uparrow></cq-uparrow> 

    <!-- Footer -->
    <cq-footer></cq-footer>

    <!-- Red Line -->
    <cq-footerredline></cq-footerredline>
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import CQUpArrow from '@/components/ui/CQUpArrow.vue'
import CQFooter from '@/components/layout/CQFooter.vue'
import CQFooterRedLine from '@/components/layout/CQFooterRedLine'
export default {
  name: 'cq-master',
  components: {
    'navbar' : Navbar,
    'cq-uparrow' : CQUpArrow,
    'cq-footer' : CQFooter,
    'cq-footerredline' : CQFooterRedLine
  },

}
</script>
